import type { FieldErrors } from 'react-hook-form';
import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    errors: FieldErrors;
  }>()
  .create(({ theme, errors }) => ({
    formField: {
      width: '100%'
    },
    summaryErrorBorder: {
      borderColor: errors.summary
        ? theme.vars.palette.error.main
        : `rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)`,
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px'
    }
  }));

export default useStyles;
